import { render } from "./BlogPost.vue?vue&type=template&id=685cc0d4&scoped=true"
import script from "./BlogPost.vue?vue&type=script&lang=js"
export * from "./BlogPost.vue?vue&type=script&lang=js"

import "./BlogPost.vue?vue&type=style&index=0&id=685cc0d4&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-685cc0d4"]])

export default __exports__